var render = function render(){var _vm=this,_c=_vm._self._c;return _c('formio-overview-component',{attrs:{"formExpansionDefinition":_vm.formDefinition,"buttonLoading":_vm.buttonLoading},on:{"cancel":_vm.onCancel}})
}
var staticRenderFns = []

export { render, staticRenderFns }